// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetArticlesListByCategoryRequestModel from '../../model/get-articles-list-by-category-request-model';
import GetArticlesListByCategoryRequestDTO from '../dto/get-articles-list-by-category-request-dto';
import dtoSchema from '../schemas/get-articles-list-by-category-request-schema';

export default abstract class GetArticlesListByCategoryRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetArticlesListByCategoryRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.id = data.id;
      this.includeChildrenCategories = data.includeChildrenCategories;
      this.isPublished = data.isPublished;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  includeChildrenCategories?: boolean;
  /**
  */
  isPublished?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetArticlesListByCategoryRequestDTO>): GetArticlesListByCategoryRequestModel;
  static toModel(dto: DeepPartial<GetArticlesListByCategoryRequestDTO> | undefined | null): GetArticlesListByCategoryRequestModel | undefined;
  static toModel(dto: DeepPartial<GetArticlesListByCategoryRequestDTO> | undefined | null): GetArticlesListByCategoryRequestModel | undefined {
    return dto ? new GetArticlesListByCategoryRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetArticlesListByCategoryRequestModel> | GetArticlesListByCategoryRequestModel): GetArticlesListByCategoryRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      id: unwrapped.id,
      includeChildrenCategories: unwrapped.includeChildrenCategories,
      isPublished: unwrapped.isPublished,
      searchCriteria: unwrapped.searchCriteria,
    } as GetArticlesListByCategoryRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetArticlesListByCategoryRequestModel, can not map to GetArticlesListByCategoryRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
